// extracted by mini-css-extract-plugin
export default {"wrapper":"SingleTextElement_wrapper__dgu-p","title":"SingleTextElement_title__0aPZA","input":"SingleTextElement_input__9oTFn"};